import { LongBody, ShortBody } from 'components/Typography';
import styled from 'styled-components';

export const StyledShortBody = styled(ShortBody)`
  margin-bottom: 5px !important;
`;

export const SizedLongBody = styled(LongBody)`
  && {
    margin-bottom: 0px;
  }
`;

export const StyledBodyText = styled.p`
  white-space: pre-line;
  color: #162952;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
  max-height: 500px;
  margin: 0px;
  overflow: auto;
`;
export const StyledPic = styled.img`
  height: 202px;
  width: 552px;
`;

export const StyledPicResponsive = styled.img`
  height: 90px;
  width: 290px;
`;
